import { useAsset } from '@ocx/data-configuration';

export const VerifiedDecoration = () => {
  const verifiedSrc = useAsset('UserVerifiedIcon');

  return (
    <img
      style={{
        display: 'block',
        boxSizing: 'border-box',
        position: 'absolute',
        left: 0,
        right: 0,
        top: -65,
        margin: '0 auto',
      }}
      width={130}
      height={130}
      src={verifiedSrc}
      alt="Achievement"
    />
  );
};
